import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '../../services/snackbar.service';
import { SubscriptionService } from '../../services/subscription.service';
import { ValidatorService } from '../../services/validator.service';

@Component({
	selector: 'app-basic-email-modal',
	templateUrl: './basic-email-modal.component.html',
	styleUrls: ['./basic-email-modal.component.scss']
})
export class BasicEmailModalComponent implements OnInit, OnDestroy {
	public form: UntypedFormGroup;
	public subscriptions: any[] = [];

	constructor(
		public dialogRef: MatDialogRef<BasicEmailModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private _formBuilder: UntypedFormBuilder,
		private _validatorService: ValidatorService,
		private _snackbarService: SnackbarService,
		private _subscriptionService: SubscriptionService
	) {
	}

	close(response?) {
		this.dialogRef.close(response);
	}

	ngOnDestroy() {
		this._subscriptionService.unSubscribe(this.subscriptions);
	}

	ngOnInit() {
		this.form = this._formBuilder.group({
			email: ['', [Validators.email]],
			emails: [[], [this._validatorService.minArrayLength(1)]],
			subject: [null, [Validators.required]],
			message: [null, [Validators.required]]
		});

		// Disable email input when 10 emails are added
		this.subscriptions.push(this.form.get('emails').valueChanges.subscribe((value) => {
			if (value?.length === 10) {
				this.form.get('email').disable();
			} else if (this.form.get('email').disabled && value?.length < 10) {
				this.form.get('email').enable();
			}
		}));
	}

	submit(form) {
		if (form.valid) {
			// Return the form values to the caller
			this.close({
				subject: form.value.subject,
				body: form.value.message,
				emails: form.value.emails
			});
		} else {
			if (this.form.get('emails').errors) {
				this.form.get('email').setErrors({minLength: true});
				this.form.get('email').markAsTouched();
			}
			this._snackbarService.openSnackBar('Please fill out all required fields.', 'Close', 3000);
		}
	}
}